var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartDOM",staticClass:"chart-dom"})
}
var staticRenderFns = []

export { render, staticRenderFns }